import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import systemRegistry from "../../services/SystemRegistry";

export const fetchAllSystems = createAsyncThunk(
  "systemRegistry/fetchAllSystems",
  async (_, { rejectWithValue }) => {
    try {
      const response = await systemRegistry.getAllSystems();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const fetchSystem = createAsyncThunk(
  "systemRegistry/fetchSystem",
  async (param: string, { rejectWithValue }) => {
    try {
      const response = await systemRegistry.getSystem(param);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const postSystem = createAsyncThunk(
  "systemRegistry/postSystem",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await systemRegistry.postSystem(data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const putSystem = createAsyncThunk(
  "systemRegistry/putSystem",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await systemRegistry.putSystem(data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const deleteSystem = createAsyncThunk(
  "systemRegistry/deleteSystem",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await systemRegistry.deleteSystem(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
